import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import API from '@sesame/web-api';

import { IRackComponent, IPortMap } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from 'src/components/Spinner';

interface IEditComponentPortmapProps {
  component: IRackComponent;
  onElevationChange: () => void;
  checkPortDestinations: (componentId: number, ports: string[]) => string[];
  elevationUpdateKey: number;
}

export const EditComponentPortmap = ({ component,
  onElevationChange,
  checkPortDestinations,
  elevationUpdateKey }: IEditComponentPortmapProps) => {

  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [portmap, setPortmap] = useState([...component.portmap, ...Array<string>(component.portCount - component.portmap.length).fill('')]);
  const [sourceList, setSourceList] = useState(Array<string>(component.portCount).fill(''));
  const [errors, setErrors] = useState(checkPortDestinations(component.componentId, portmap));

  const onChange = (e: React.FormEvent<HTMLInputElement>, i: number) => {
    const newVal = e.currentTarget.value.toUpperCase();
    portmap[i] = newVal;
    component.portmap[i] = newVal;
    setPortmap([...portmap]);
    setErrors(checkPortDestinations(component.componentId, portmap));
  }
  const onSave = () => {
    getAccessTokenSilently().then(accessToken => {
      API.post(accessToken, `/api/v1/component/${component.componentId}/portmap`, portmap)
        .then(res => {
          Alert(AlertTypes.SUCCESS, "Ports saved");
        })
        .catch(err => {
          Alert(AlertTypes.ERROR, err.message);
        });
      for (let i = 0; i < portmap.length; i++) {
        component.portmap[i] = portmap[i];
      }
      onElevationChange();
    })
  }

  const getMappedPorts = () => {
    getAccessTokenSilently().then( accessToken => {
    API.get(accessToken, `/api/v1/rack/${component.rackId}/portmap`)
      .then(res => {
        const sources = res.data as IPortMap[];
        const newSourceList = Array<string>(component.portCount).fill('');
        for (let i = 0; i < sources.length; i++) {
          const s = sources[i];
          if (s.destination.label == component.label) {
            const destPort = s.destination.port;
            if (destPort <= component.portCount) {
              if (newSourceList[s.destination.port]) {
                newSourceList[s.destination.port - 1] += ' ';
              }
              newSourceList[s.destination.port - 1] += s.source.location.ou + ':' + s.source.location.column
            }
          }
        };
        setSourceList(newSourceList);
      })
      .catch(err => {
        Alert(AlertTypes.ERROR, err.message);
      });
    })
  }

  let errorClass = Array<string>(component.portCount).fill('');
  errors.forEach((e, i) => {
    switch (e) {
      case 'InvalidReference': errorClass[i] = "uk-text-danger"; break;
      case 'InvalidSwitch': errorClass[i] = "uk-text-danger"; break;
      case 'TooManyPorts': errorClass[i] = "uk-text-danger"; break;
      case 'InvalidPort': errorClass[i] = "uk-text-danger"; break;
      case 'Valid': errorClass[i] = "uk-text-success"; break;
      default: errorClass[i] = '';
    }
  });

  useEffect(() => getMappedPorts(), [elevationUpdateKey, getAccessTokenSilently]);

  if(isLoading) {
    return <Spinner />
  }

  if (!component.portCount) {
    return <></>;
  }
  return <div>
    {portmap.map((p, i) => <input
      type="text"
      key={i}
      size={2}
      value={sourceList[i] ? sourceList[i] : p}
      disabled={sourceList[i] != ''}
      className={`uk-input uk-form-small uk-form-width-small ${errorClass[i]}`}
      data-uk-tooltip={`title: ${errors[i]}; pos: bottom-left`}
      maxLength={12}
      placeholder={`P${i + 1}`}
      onChange={e => onChange(e, i)}
    />)}
    <a className="uk-button uk-button-secondary"
      onClick={e => onSave()} data-uk-icon="check"></a>
  </div>
}
